import React from "react";
import { Button } from "@/shared/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/shared/components/ui/select";
import { useLanguage } from "@/shared/components/shared/LanguageContext";

export default function LogFilters({
  logStatusFilter,
  setLogStatusFilter,
  logStartDate,
  setLogStartDate,
  logEndDate,
  setLogEndDate,
  onReset,
}) {
  const { t } = useLanguage();

  return (
    <>
      {/* Status Filter */}
      <div className="p-4 bg-slate-50 rounded-lg">
        <div className="space-y-1">
          <p className="text-xs font-medium text-slate-500">{t("filterByStatus")}</p>
          <Select value={logStatusFilter} onValueChange={setLogStatusFilter}>
            <SelectTrigger className="w-full bg-white">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="ALL">{t("allStatuses")}</SelectItem>
              <SelectItem value="UP">{t("statusUp")}</SelectItem>
              <SelectItem value="LOW">{t("statusLow")}</SelectItem>
              <SelectItem value="CRITICAL">{t("statusCritical")}</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>

      {/* Date Filters */}
      <div className="flex flex-col sm:flex-row sm:items-end gap-3 p-4 bg-slate-50 rounded-lg">
        <div className="space-y-1 w-full">
          <p className="text-xs font-medium text-slate-500">{t("fromDate")}</p>
          <input
            type="date"
            value={logStartDate}
            onChange={(e) => setLogStartDate(e.target.value)}
            className="px-1 py-1 rounded-lg bg-white w-full"
          />
        </div>
        <div className="space-y-1 w-full">
          <p className="text-xs font-medium text-slate-500">{t("toDate")}</p>
          <input
            type="date"
            value={logEndDate}
            onChange={(e) => setLogEndDate(e.target.value)}
            className="px-1 py-1 rounded-lg bg-white w-full"
          />
        </div>
        <Button variant="ghost" size="sm" onClick={onReset} className="text-slate-500 h-10">
          {t("reset")}
        </Button>
      </div>
    </>
  );
}
